

















































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { percentFromTotal } from "../../../utils";
import PaceAvgIcon from "@/assets/images/paceAvg.svg?inline";

@Component({
  components: { PaceAvgIcon }
})
export default class AveragePace extends Vue {
  
  @Prop() private avg!: number;
  private avgRound:number = 0;
  private redColor = "#F74657"
  private yellowColor = "#FFCC00"
  private greenColor = "#38D17A";
  private averagePaceColor: string = this.redColor;
  private averagePacePercentage: number = 0;
  private lowMinRed = 30
  private lowMaxRed = 109
  private lowMinYellow = 110
  private lowMaxYellow = 134
  private lowMinGreen = 135
  private lowMaxGreen = 150
  private highMinGreen = 151
  private highMaxGreen = 165
  private highMinYellow = 166
  private highMaxYellow = 190
  private highMinRed = 191
  private highMaxRed = 250

  private created() {
    this.displayData()
  }

  @Watch("avg")
  private displayData() {
    this.setAvgPaceText();
    this.setPaceColor();
  }

  private setAvgPaceText() {

    const width = 100/6;
    this.avgRound = Math.floor(this.avg);
    if(this.avgRound <= this.lowMaxRed) {

      let localAvg = this.avgRound;
      if (localAvg < this.lowMinRed) {
        localAvg = this.lowMinRed;
      }
      const avgPace = localAvg - this.lowMinRed;
      this.averagePacePercentage = (avgPace * width) / (this.lowMaxRed - this.lowMinRed);
      
   } else if(this.avgRound >= this.lowMinYellow && this.avgRound <= this.lowMaxYellow) {

      const avgPace = this.avgRound - this.lowMinYellow;
      this.averagePacePercentage = (avgPace * width) / (this.lowMaxYellow - this.lowMinYellow);
      this.averagePacePercentage += width;

    } else if(this.avgRound >= this.lowMinGreen && this.avgRound <= this.lowMaxGreen) {

      const avgPace = this.avgRound - this.lowMinGreen;
      this.averagePacePercentage = (avgPace * width) / (this.lowMaxGreen - this.lowMinGreen);
      this.averagePacePercentage += (width*2);

    } else if(this.avgRound >= this.highMinGreen && this.avgRound <= this.highMaxGreen) {

      const avgPace = this.avgRound - this.highMinGreen;
      this.averagePacePercentage = (avgPace * width) / (this.highMaxGreen - this.highMinGreen);
      this.averagePacePercentage += (width*3);

    } else if(this.avgRound >= this.highMinYellow && this.avgRound <= this.highMaxYellow) {
      
      const avgPace = this.avgRound - this.highMinYellow;
      this.averagePacePercentage = (avgPace * width) / (this.highMaxYellow - this.highMinYellow);
      this.averagePacePercentage += (width*4);
      
    } else if(this.avgRound >= this.highMinRed && this.avgRound <= this.highMaxRed) {

      const avgPace = this.avgRound - this.highMinRed;
      this.averagePacePercentage = (avgPace * width) / (this.highMaxRed - this.highMinRed);
      this.averagePacePercentage += (width*5);
    }
    this.averagePacePercentage -= 9;
  }

  private setPaceColor() {
    if(this.avgRound <= this.lowMaxRed || this.avgRound >= this.highMinRed) {
      this.averagePaceColor = this.redColor;
    } else if((this.avgRound >= this.lowMinYellow && this.avgRound <= this.lowMaxYellow) 
      || (this.avgRound >= this.highMinYellow && this.avgRound <= this.highMaxYellow)) {
      this.averagePaceColor = this.yellowColor;
    } else {
      this.averagePaceColor = this.greenColor;
    }
  }
}

